export default __webpack_public_path__ + "static/icon_tags.f4483328dc66fc2129a9044501f07e03.png";